import { z } from "zod";
import { energyTypeSchema } from "@qivia/schemas-shared";

export const getSivDataByRegistrationNumberResponseSchema = z.object({
  model: z.string(),
  modelVersion: z.string(),
  brand: z.string(),
  cylinder: z.number().int().nullable(),
  year: z.number().int(),
  energy: z.string(),
  energyType: energyTypeSchema.nullable(),
  vehicleBody: z.string(),
  carIconUrl: z.string().nullable(),
});

export type GetSivDataByRegistrationNumberResponse = z.infer<
  typeof getSivDataByRegistrationNumberResponseSchema
>;
